import api from "./api";

export const settingsApi = {
  getMy: () => api.get("/settings/me"),
  updateMy: (payload) => api.put("/settings/me", payload),
};